/* eslint-disable tss-unused-classes/unused-classes */
import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useCommonStyles = makeStyles()((theme) => ({
  fileItem: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(19.5),
    height: theme.spacing(12.5),
    padding: theme.spacing(1),
    border: `2px dashed ${alpha(theme.palette.primary.main, 0.5)}`,
    borderRadius: theme.spacing(1),
    transition: theme.transitions.create('border'),
    cursor: 'pointer',
    '&:hover': {
      borderColor: alpha(theme.palette.primary.main, 1),
    },
    [theme.breakpoints.down('md')]: {
      width: theme.spacing(10),
      height: theme.spacing(10),
    },
  },
}));
